import React from 'react';
import { Button, ButtonProps } from '@mui/material';
import { tokens } from './tokens';

const buttonSx = { width: '100%', py: '15px', borderRadius: '16px', fontSize: '16px', fontWeight: 600 };

export const PrimaryButton: React.FC<ButtonProps> = ({ sx, ...props }) => (
  <Button variant="contained" disableElevation sx={{ ...buttonSx, ...sx }} {...props} />
);

export const SecondaryButton: React.FC<ButtonProps> = ({ sx, ...props }) => (
  <Button
    variant="outlined"
    sx={{
      ...buttonSx,
      borderWidth: 2,
      borderColor: 'primary.main',
      color: tokens.textPrimary,
      '&:hover': { borderWidth: 2 },
      ...sx,
    }}
    {...props}
  />
);
